var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toggle-switch"},[_c('input',{ref:"input",staticClass:"checkbox",attrs:{"type":"checkbox","id":_vm.id || 'toggle'},domProps:{"checked":_vm.computedIsChecked},on:{"change":_vm.handleChange}}),_c('label',{staticClass:"switch",attrs:{"for":_vm.id || 'toggle'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }